// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"ToolboxImport_dropzone__3aP2C"};